import React, { useEffect, useState } from "react";
import messages from "../../assets/locale/messages";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Button from "../../components/Button";
import { Form, Formik } from "formik";
import Search from "../../components/Search";
import AddIcon from "@material-ui/icons/Add";
import { ROUTE_PATHS } from "../../utils/PathsNames";
import FinalTestList from "./FinalTestList";
import EmptyState from "../../components/EmptyState";
import Pagination from "../../components/Pagination";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  getAllFinalTestsRequest,
  setFinalTestSearch,
  setFinalTestsPage
} from "../../store/FinalTests/actions";
import FinalTestDelete from "./FinalTestDelete";
import Title_Section from "../../components/Title_Section/Title_Section";
import styles from "./FinalTests.module.scss";
function FinalTests() {
  const dispatch = useDispatch();

  const [deleteModal, setDeleteModal] = useState({
    open: false,
    id: 0
  });
  const {
    meta,
    list: finalTestList,
    finalTestsPage
  } = useSelector((state) => state.finalTestsReducer);

  // console.log("finalTestList", finalTestList);

  const lang = useSelector((state) => state.locale.lang);
  // console.log("meta", meta);
  const isLoading = useSelector((state) => state.loader);
  const perPage = 6;

  const [page, setPage] = useState(1);

  const handleSearch = (e) => {
    const search = e.target.value;
    dispatch(setFinalTestSearch(search ? search : ""));
    dispatch(
      getAllFinalTestsRequest({
        book_name: search ? search : "",
        page: 1,
        items: perPage
        // paginate: true
      })
    );
  };

  useEffect(() => {
    dispatch(
      getAllFinalTestsRequest({
        page: finalTestsPage,
        items: perPage
      })
    );
  }, [finalTestsPage]);

  const handlePagination = (event, page) => {
    setPage(page);
    dispatch(
      getAllFinalTestsRequest({
        book_name: "",
        page: page,
        items: perPage
      })
    );
  };
  const {
    finalTest: { title, addFinalTest }
  } = messages[lang];
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <Title_Section title={title} />
      </div>
      <Grid container spacing={3} className="mb-2">
        <Grid item xs={6}>
          <Formik initialValues={{ search: "" }}>
            {() => (
              <Form>
                <Search
                  name="search"
                  placeholder="Search"
                  onChange={handleSearch}
                />
                <button className="d-none"></button>
              </Form>
            )}
          </Formik>
        </Grid>
        <Grid
          item
          xs={6}
          className="d-flex align-items-start justify-content-end"
        >
          <Button
            text={addFinalTest}
            icon={<AddIcon className="me-2" />}
            isLink={true}
            slug={`${ROUTE_PATHS.finalTestForm}/Add`}
          />
        </Grid>
      </Grid>
      <FinalTestList
        list={finalTestList}
        lang={lang}
        setDeleteModal={setDeleteModal}
        inBookView={false}
      />
      {!isLoading && !finalTestList?.length && <EmptyState />}
      <FinalTestDelete
        setDeleteModal={setDeleteModal}
        isOpen={deleteModal.open}
        id={deleteModal.id}
        lang={lang}
      />
      <div className={styles.footerDiv}>
        {meta.pages > 1 && (
          <>
            <div className={styles.PageNumberDiv}>
              <label htmlFor="pageInput">Page Number&nbsp;</label>
              <input
                id="pageInput"
                value={page}
                className={styles.InputPage}
                type="number"
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setPage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    dispatch(
                      setFinalTestsPage({ page: Number(page) })
                    );
                  }
                }}
              />
              <button
                className={styles.ArrowButton}
                onClick={() =>
                  dispatch(setFinalTestsPage({ page: Number(page) }))
                }
                title="Go To Page"
              >
                <ArrowForwardIcon className="mx-2" />
              </button>
            </div>
            <Pagination
              count={meta.pages}
              page={meta.currentPage || page}
              handleChange={handlePagination}
            />
          </>
        )}
      </div>
    </>
  );
}

export default FinalTests;
